import { Component, Input, OnInit } from '@angular/core';
import { Installation } from '../../../interfaces/facilty';
import { Observable } from 'rxjs';
import { AppModel, HeatExchangerSystemState } from '@ams/dumbledore';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { DataPointsResult, SystemDevice } from '../../../interfaces/data-points';
import { filter, map } from 'rxjs/operators';
import { systemsToValveDevice } from '../../../utils/data-point-utils';
import { systemHasEnergyValve } from 'projects/dumbledore/src/schematic/util/system-properties-util';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { HeatMeterStatusTileComponent } from '../../heat-meter-status-tile/heat-meter-status-tile.component';
import { ValveStatusTileComponent } from '../../valve-status-tile/valve-status-tile.component';
import { BuildingConnectWeatherCurveTileComponent } from '../../charts/building-connect-weather-curve-tile/building-connect-weather-curve-tile.component';
import { ForwardReturnChartTileComponent } from '../../charts/forward-return-chart-tile/forward-return-chart-tile.component';
import { ValveChartComponent } from '../../charts/valve-chart/valve-chart.component';
import { EnergyValveHeatAndFlowChartComponent } from '../../charts/energy-valve-heat-and-flow-chart/energy-valve-heat-and-flow-chart.component';
import { EnergyValveTemperatureChartComponent } from '../../charts/energy-valve-temperature-chart/energy-valve-temperature-chart.component';
import { DifferentialPressureChartComponent } from '../../charts/differential-pressure-chart/differential-pressure-chart.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-heat-exchanger-dashboard',
    templateUrl: './heat-exchanger-dashboard.component.html',
    styleUrls: ['./heat-exchanger-dashboard.component.scss'],
    imports: [
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    HeatMeterStatusTileComponent,
    ValveStatusTileComponent,
    BuildingConnectWeatherCurveTileComponent,
    ForwardReturnChartTileComponent,
    ValveChartComponent,
    EnergyValveHeatAndFlowChartComponent,
    EnergyValveTemperatureChartComponent,
    DifferentialPressureChartComponent,
    TranslateModule,
    AsyncPipe
]
})
export class HeatExchangerDashboardComponent implements OnInit {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() public application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;

  public hasEnergyValve$: Observable<boolean | undefined>;
  public hasPrimaryTemperatureSensors$: Observable<boolean | undefined>;
  public weatherCompensationEnabled$: Observable<boolean>;
  public outdoorTemp$: Observable<number | null>;
  public valveDevice$: Observable<SystemDevice | undefined>;
  private system$: Observable<HeatExchangerSystemState>;

  constructor() {}

  ngOnInit(): void {
    this.system$ = this.schematic$.pipe(
      map((schematic) => {
        return schematic.systems.find((s) => s.hasId === this.application.id) as HeatExchangerSystemState;
      })
    );

    this.valveDevice$ = this.dataPoints$.pipe(systemsToValveDevice(this.application.id));

    this.weatherCompensationEnabled$ = this.system$.pipe(
      map((system) => {
        return system?.systemInfo?.Weather_compensation_enabled || false;
      })
    );

    this.outdoorTemp$ = this.dataPoints$.pipe(
      filter((d) => !!d?.data),
      map((dataPoints) => {
        const allDataPoints = dataPoints.data.flatMap((s) => s.devices).flatMap((d) => d.dataPoints);
        const outdoorTempDataPoint = allDataPoints.find((dataPoint) => dataPoint.dumbledoreId === 'T_OUTDOOR');
        return outdoorTempDataPoint?.value ? parseInt(outdoorTempDataPoint.value, 10) : null;
      })
    );

    this.hasEnergyValve$ = this.system$.pipe(
      map((system) => {
        return systemHasEnergyValve(system?.systemInfo);
      })
    );

    this.hasPrimaryTemperatureSensors$ = this.system$.pipe(
      map((system) => {
        return (system?.systemInfo.T_PF_present || system?.systemInfo.T_PR_present || system?.systemInfo.HM_present);
      })
    );
  }
}
